import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const Bubble = styled.div`
  @keyframes autoPopIn {
    0% {
      opacity: 0;
      transform: scale(0.5) translateX(30%);
    }
    65% {
      opacity: 50%;
      transform: scale(1.05) translateX(-1%);
    }
    100% {
      opacity: 1;
      transform: scale(1) translateX(0);
    }
  }

  animation: autoPopIn 0.5s linear 1;
  animation-fill-mode: both;
  position: fixed;
  bottom: 110px;
  right: 25px;
  background: #fff;
  color: #333;
  padding: 12px;
  font-size: 14px;
  max-width: 300px;
  border-radius: 5px;
  box-shadow: 0px 1px 4px 0 rgba(0, 0, 0, 0.3);
  text-align: left;
`

const ChatBubble = ({ text, delay }) => {
  const [show, setShow] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true)
    }, (delay || 0) * 1000)
    return () => clearTimeout(timer)
  }, [])

  if (!show || !text) { return null }

  return (
    <Bubble onClick={() => setShow(false)}>{text}</Bubble>
  )
}

export default ChatBubble



// WEBPACK FOOTER //
// ./src/ChatWidget/components/ChatBubble/index.js